const crossfadeDurationMs = 225;
const wrapper = "_35swcvipmk";
const linebreak = "_35sl10awe7q";
const toggle = "_35stigwh08";
const content = "_35sc1eau6l3";
const transitionWrapper = "_35stlm86jf";

export { content, crossfadeDurationMs, linebreak, toggle, transitionWrapper, wrapper };
import "./_task.dropdown.style.linaria.module.css";
//# sourceMappingURL=_task.dropdown.style.js.map
